import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { AccessGroup } from '../access-group/access-group.model';
import { Account } from '../account/account.model';
import { CategoryStoreFacade } from '../category/category.store-facade';
import { Qry } from '../query-facade';
import { User } from '../user/user.model';
import * as actions from './job-status.actions';
import { JobStatus } from './job-status.model';
import * as selectors from './job-status.selectors';

export class JobStatusStoreFacade extends CategoryStoreFacade<JobStatus> {

    defaultSortFn = (a: AccessGroup, b: AccessGroup) => a.sequence - b.sequence;

    getAll(): Observable<Array<JobStatus>> {
        return this.select(selectors.getAll);
    }

    getForAllAccounts(): Observable<Array<JobStatus>> {
        return this._getForAllAccounts('jobStatus', 'jobStatuses');
    }

    getActiveList(): Observable<Array<JobStatus>> {
        return this.select<Array<JobStatus>>(Qry.getInstance().jobStatus.byActiveAccount)
            .map(jobStatuses => jobStatuses.filter(jobStatus => jobStatus && !jobStatus.closed));
    }

    getByAccountUser(account: Account, user: User): Observable<Array<JobStatus>> {
        return this.select(Qry.getInstance().jobStatus.byAccount(account.id));
    }

    getFiltered(): Observable<Array<JobStatus>> {
        return this.select(Qry.getInstance().jobStatus.filtered);
    }

    create(jobStatus: JobStatus): void {

        this.dispatch(new actions.SubmitAction(jobStatus));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachJobStatus(membership, jobStatus, {restful: false, persistable: true});
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    update(jobStatus: JobStatus): void {
        this.dispatch(new actions.SubmitAction(jobStatus));
    }

    insert(jobStatus: JobStatus): void {
        this.dispatch(new actions.SubmitAction(jobStatus, {persistable: true, restful: false}));
    }

    remove(jobStatus: JobStatus, options?: ActionOptionsArgs): void {
        this.appFacade.objects.job.store.removeByJobStatus(jobStatus, options);

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachJobStatus(membership, jobStatus, {restful: false, persistable: true});
        });

        this.dispatch(new actions.RemoveAction(jobStatus, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    setFilters(filers): void {
        this.dispatch(new actions.SetFilterAction(filers));
    }

    canDelete(jobStatus: JobStatus): Observable<boolean> {
        return this.checkHasDependency(this.appFacade.objects.job.store, jobStatus, 'Jobs')
            .switchMap(() => super.canDelete(jobStatus));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.store-facade.ts